<template>
  <section>
    <breadcrumbs></breadcrumbs>
    <!-- 查询条件 -->
    <el-form
      ref="searchForm"
      :model="searchForm"
      label-width="100px"
      inline
      class="demo-form-inline"
      size="small"
      style="border-bottom: 1px solid var(--table-border);"
    >
      <el-form-item label="用户名称" prop="customerName">
        <el-input
          v-model="searchForm.customerName"
          placeholder="请输入用户名称"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <btns @exec="exec"></btns>
    <div class="data-container scroll-table">
      <div>
        <div class="ind-title lh50 f16">用户列表</div>
      </div>
      <!-- 用户列表 -->
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        @selection-change="tableSelectionChange"
      >
        <el-table-column type="selection" width="40"> </el-table-column>
        <el-table-column prop="customerName" label="用户名称">
        </el-table-column>
        <el-table-column prop="roleName" label="用户角色"> </el-table-column>
        <el-table-column prop="roleSceneName" label="角色场景">
        </el-table-column>
        <el-table-column prop="customerPhone" label="用户电话">
        </el-table-column>

        <el-table-column prop="customerStatus" label="状态">
          <template slot-scope="scope">
            <el-link
              v-if="scope.row.customerStatus == 0"
              type="danger"
              :underline="false"
              >禁用</el-link
            >
            <el-link v-if="scope.row.customerStatus == 1" :underline="false"
              >启用</el-link
            >
          </template>
        </el-table-column>
        <el-table-column prop="addTime" label="创建时间"> </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="look(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mgt-20"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[5, 20, 30, 40, 50]"
        :page-size="pageSize"
        layout=" prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 编辑 -->

    <el-dialog
      title="编辑"
      :visible.sync="addORUpdateVisible2"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form
        :model="userForm1"
        label-width="120px"
        :rules="rules"
        ref="userForm"
      >
        <el-form-item label="用户角色" prop="roleId">
          <el-select
            v-model="userForm1.roleId"
            @change="getrole()"
            placeholder="请选择用户角色"
          >
            <el-option
              :label="v.roleName"
              :value="v.roleId"
              v-for="(v, i) in roleData"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addORUpdateVisible2 = false">取消</el-button>
        <el-button type="primary" @click.native="getabbing">提交</el-button>
      </div>
    </el-dialog>

    <!-- 用户详情 -->
    <el-dialog
      title="查看"
      :visible.sync="lookUserDetail"
      width="700px"
      :close-on-click-modal="false"
      center
    >
      <el-descriptions title="用户信息" border>
        <el-descriptions-item label="电话号码">{{
          lookDetail.customerPhone
        }}</el-descriptions-item>
        <el-descriptions-item label="用户名称">{{
          lookDetail.customerName
        }}</el-descriptions-item>
        <!-- <el-descriptions-item label="用户密码">{{
          lookDetail.customerPassword
        }}</el-descriptions-item> -->
        <el-descriptions-item label="用户角色">{{
          lookDetail.roleName
        }}</el-descriptions-item>
        <el-descriptions-item label="角色场景">{{
          lookDetail.roleSceneName
        }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{
          lookDetail.addTime
        }}</el-descriptions-item>
        <el-descriptions-item label="账号状态">
          <span
            v-text="lookDetail.customerStatus === 1 ? '启用' : '禁用'"
          ></span>
        </el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="lookUserDetail = false">已 知 晓</el-button>
      </span>
    </el-dialog>
    <!--新增修改界面-->
    <el-dialog
      :title="funTit == 'add' ? '新增' : '修改'"
      :visible.sync="addORUpdateVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form
        :model="userForm"
        label-width="120px"
        :rules="rules"
        ref="userForm"
      >
        <el-form-item label="电话号码" prop="customerPhone">
          <el-input
            v-model="userForm.customerPhone"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户名称" prop="customerName">
          <el-input
            v-model="userForm.customerName"
            auto-complete="off"
          ></el-input>
        </el-form-item>

        <!-- <el-form-item label="身份证号码" prop="idcard">
          <el-input v-model="userForm.idcard" auto-complete="off"></el-input>
        </el-form-item> -->
        <el-form-item label="用户角色" prop="roleId">
          <el-select
            v-model="userForm.roleId"
            @change="getrole()"
            placeholder="请选择用户角色"
          >
            <el-option
              :label="v.roleName"
              :value="v.roleId"
              v-for="(v, i) in roleData"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addORUpdateVisible = false">取消</el-button>
        <el-button type="primary" @click.native="submit('userForm')"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import {
  validateMobilePhone,
  validatePass,
  validateCode,
} from "../../utils/tool";
import store from "../../store";

import btns from "@/components/btns.vue";

export default {
  components: {
    btns,
    breadcrumbs,
  },
  data() {
    return {
      lookUserDetail: false,
      userForm1: {
        roleId: "",
      },
      searchForm: {
        customerName: "",
        totalCount: 0,
        current: 1,
        size: 10,
      },
      // 分页数据
      pageNum: 1, // 当前页，默认
      pageSize: 5, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      isotherAdmin: false,
      addORUpdateVisible2: false,
      addORUpdateVisible: false,
      funTit: "",
      userForm: {
        customerName: "",
        password: "",
        roleId: "",
        customerPhone: "",
        idcard: "",
      },
      rules: {
        customerName: [
          { required: true, message: "请输入用户名称", trigger: "blur" },
        ],
        roleId: [
          { required: true, message: "请选择用户角色", trigger: "blur" },
        ],
        customerPhone: [
          { required: true, message: "请输入电话号码", trigger: "blur" },
          { validator: validateMobilePhone, trigger: "blur" },
        ],
        // idcard: [
        //   {
        //     required: true,
        //     message: "请输入身份证号码",
        //     trigger: "blur",
        //     maxlengh: 18,
        //   },
        //   { min: 18, max: 18, message: "身份证必须是18位", trigger: "blur" },
        // ],
        password: [
          { required: true, message: "请输入用户密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" },
        ],
      },
      tableData: [],
      tableSelection: [],
      roleData: [],
      lookDetail: {},
    };
  },
  created() {
    this.customerlist();
    this.rolelist();
  },
  methods: {
    look(row) {
      this.lookDetail = row;
      this.lookUserDetail = true;
    },
    getabbing() {
      this.$api.admincustomerq
        .getupdatelis({
          customerId: this.userForm1.customerId,
          roleId: this.userForm1.roleId,
        })
        .then((d) => {
          if (d.code == 200) {
            this.addORUpdateVisible2 = false;
            this.$refs.userForm1.resetFields();
            this.$message.success("修改成功");
            this.customerlist();
          } else {
            this.$message.error(d.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    getrole() {
      let roleId = this.userForm.roleId;
      this.roleData.forEach((item) => {
        if (item.roleId == roleId) {
          console.log("item", item);
          this.userForm.roleName = item.roleName;
          this.userForm.roleId = item.roleId;
        }
      });
    },
    handleSizeChange(v) {
      this.pageSize = v;
      this.customerlist(this.pageNum);
    },
    handleCurrentChange(v) {
      this.pageNum = v;
      this.customerlist(this.pageNum);
    },
    rolelist() {
      //获取接口
      this.$api.role
        .roleXiala({})
        .then((d) => {
          console.log(d, "角色下拉");
          if (d.code == 200) {
            this.roleData = d.data;
            // console.log(this.roleData, "roleData")
          } else {
            this.$message.error(d.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    customerlist(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      //获取接口
      this.$api.admincustomerq
        .managerList({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          customerName: this.searchForm.customerName,
        })
        .then((d) => {
          if (d.code == 200) {
            d.data.list.forEach((element) => {
              element.roleSceneName = element.customerSceneType
                .split(",")
                .map((data) => {
                  return data == 1
                    ? "景区场景"
                    : data == 2
                    ? "校园场景"
                    : data == 3
                    ? "社区场景"
                    : "";
                })
                .toString();
            });

            this.tableData = d.data.list;
            this.total = d.data.total;
          } else {
            this.$message.error(d.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.search();
    },
    search() {
      this.customerlist();
    },
    tableSelectionChange(val) {
      this.tableSelection = val;
    },
    exec(fun) {
      console.log(fun);
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
    add() {
      this.userForm = {
        customerName: "",
        password: "",
        roleId: "",
        customerPhone: "",
        idcard: "",
      };
      this.addORUpdateVisible = true;
    },
    update() {
      if (this.tableSelection.length != 1) {
        this.$message.error("请选中一行数据");
        return;
      }
      if (this.tableSelection[0].roleName === "超级管理员") {
        this.$message.error("超级管理员不允许编辑");
        return;
      }
      console.log(this.tableSelection[0]);
      this.userForm = this.tableSelection[0];
      this.addORUpdateVisible = true;
    },
    del() {
      if (this.tableSelection.length != 1) {
        this.$message.error("请选中一行数据");
        return;
      }
      if (this.tableSelection[0].roleName === "超级管理员") {
        this.$message.error("超级管理员不允许删除");
        return;
      }
      var demo = this.tableSelection[0];
      this.$confirm("此操作将删除该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$api.admincustomer
          .delUser({ id: demo.id })
          .then((d) => {
            if (d.code == 200) {
              this.customerlist();
              this.$message.success("删除成功");
            } else {
              this.$message.error(d.msg);
            }
          })
          .catch((e) => {
            console.log(e);
          });
      });
    },
    enable() {
      if (this.tableSelection.length != 1) {
        this.$message.error("请选中一行数据");
        return;
      }
      if (this.tableSelection[0].roleName === "超级管理员") {
        this.$message.error("超级管理员不允许操作");
        return;
      }
      var demo = this.tableSelection[0];
      if (demo.customerStatus == 1) {
        this.$message.error("该数据已启用");
        return;
      }
      this.$confirm("此操作将启用该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$api.admincustomerq
          .getddupdateStatus({ id: demo.id, usingStatus: 1 })
          .then((d) => {
            if (d.code == 200) {
              this.customerlist();
              this.$message.success("启用成功");
            } else {
              this.$message.error(d.msg);
            }
          })
          .catch((e) => {
            console.log(e);
          });
      });
    },

    disable() {
      if (this.tableSelection.length != 1) {
        this.$message.error("请选中一行数据");
        return;
      }

      if (this.tableSelection[0].roleName === "超级管理员") {
        this.$message.error("超级管理员不允许操作");
        return;
      }

      const phoneReg = /^(\d{3})\d{5}(\d{3})$/;
      // eslint-disable-next-line no-unused-vars
      var phone = this.tableSelection[0].customerPhone;
      phone = phone.replace(phoneReg, "$1*****$2");
      if (phone == store.getters.get_token.customerPhone) {
        this.$message.error("无法禁用该登录的用户");
        return;
      }
      var demo = this.tableSelection[0];
      if (demo.customerStatus == 0) {
        this.$message.error("该数据已禁用");
        return;
      }
      this.$confirm("此操作将禁用该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$api.admincustomerq
          .getddupdateStatus({ id: demo.id, usingStatus: 0 })
          .then((d) => {
            if (d.code == 200) {
              this.customerlist();
              this.$message.success("禁用成功");
            } else {
              this.$message.error(d.msg);
            }
          })
          .catch((e) => {
            console.log(e);
          });
      });
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.funTit == "add") {
            this.$api.admincustomerq
              .getyhxadd(this.userForm)
              .then((d) => {
                if (d.code == 200) {
                  this.addORUpdateVisible = false;
                  this.$refs.userForm.resetFields();
                  this.$message.success("新增成功");
                  this.customerlist();
                } else {
                  this.$message.error(d.msg);
                }
              })
              .catch((e) => {
                console.log(e);
              });
          } else {
            this.$api.admincustomerq
              .getupdatelis(this.userForm)
              .then((d) => {
                if (d.code == 200) {
                  this.addORUpdateVisible = false;
                  this.$refs.userForm.resetFields();
                  this.$message.success("修改成功");
                  this.customerlist();
                } else {
                  this.$message.error(d.msg);
                }
              })
              .catch((e) => {
                console.log(e);
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
